/**
 * Home Page Component
 * Landing page with searchable employee list
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useKaryawan } from "../hooks/useKaryawan";
import KaryawanCard from "./KaryawanCard";

const Home = () => {
  const navigate = useNavigate();
  const { karyawanOptions, loading, error } = useKaryawan();
  const [searchKaryawan, setSearchKaryawan] = useState("");

  const handleKaryawanClick = (nama) => {
    navigate(`/form/${encodeURIComponent(nama)}`);
  };

  // Filter employees based on search
  const filteredKaryawan = karyawanOptions.filter(
    (k) =>
      k.nama.toLowerCase().includes(searchKaryawan.toLowerCase()) ||
      k.departemen.toLowerCase().includes(searchKaryawan.toLowerCase())
  );

  return (
    <div className="App">
      <div className="form-container">
        <h1>📋 Form Penilaian Kepuasan Pasien</h1>
        <h2>Rumah Sakit Aisyiyah Siti Fatimah</h2>
        <p className="subtitle">Pilih nama karyawan yang ingin dinilai</p>

        {loading ? (
          <div className="loading">Memuat data karyawan...</div>
        ) : error ? (
          <div className="no-data">Error: {error}</div>
        ) : karyawanOptions.length === 0 ? (
          <div className="no-data">Tidak ada data karyawan tersedia</div>
        ) : (
          <>
            {/* Search Box */}
            <div className="search-karyawan-box">
              <input
                type="text"
                className="search-karyawan-input"
                placeholder="🔍 Cari nama karyawan atau departemen..."
                value={searchKaryawan}
                onChange={(e) => setSearchKaryawan(e.target.value)}
              />
              {searchKaryawan && (
                <button
                  className="clear-search-btn"
                  onClick={() => setSearchKaryawan("")}
                  title="Hapus pencarian"
                >
                  ✕
                </button>
              )}
            </div>

            {/* Search Info */}
            {searchKaryawan && (
              <div className="search-info">
                Menampilkan {filteredKaryawan.length} dari{" "}
                {karyawanOptions.length} karyawan
              </div>
            )}

            {/* Employee Grid */}
            {filteredKaryawan.length === 0 ? (
              <div className="no-data">
                Tidak ada karyawan yang sesuai dengan pencarian "
                {searchKaryawan}"
              </div>
            ) : (
              <div className="karyawan-grid">
                {filteredKaryawan.map((k) => (
                  <KaryawanCard
                    key={k.nik}
                    karyawan={k}
                    onClick={handleKaryawanClick}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
